__turbopack_context__.v({
  "arrow": "HeroSlider-module__pPN_PW__arrow",
  "bottomGradient": "HeroSlider-module__pPN_PW__bottomGradient",
  "button": "HeroSlider-module__pPN_PW__button",
  "content": "HeroSlider-module__pPN_PW__content",
  "contentWrapper": "HeroSlider-module__pPN_PW__contentWrapper",
  "current": "HeroSlider-module__pPN_PW__current",
  "indicator": "HeroSlider-module__pPN_PW__indicator",
  "indicators": "HeroSlider-module__pPN_PW__indicators",
  "login": "HeroSlider-module__pPN_PW__login",
  "main": "HeroSlider-module__pPN_PW__main",
  "pegiWrapper": "HeroSlider-module__pPN_PW__pegiWrapper",
  "slide": "HeroSlider-module__pPN_PW__slide",
  "slideTitle": "HeroSlider-module__pPN_PW__slideTitle",
  "slider": "HeroSlider-module__pPN_PW__slider",
  "sliderControls": "HeroSlider-module__pPN_PW__sliderControls",
  "topGradient": "HeroSlider-module__pPN_PW__topGradient",
});
